<template>
    <div class="element" @click="selectElement(id, name, imgSrc, multiple_fans)"
         :ref="name">

        <div class="img-container">
            <img :src="'data:image/svg+xml;base64, ' + imgSrc" alt="fan_mode_select_image">
        </div>
        <div class="name-container">
            <span class="text">{{translate(name)}}</span>
        </div>

    </div>
</template>

<script>

    export default {
        name: "SecondStepElement",
        props: ['id', 'name', 'imgSrc', 'multiple_fans'],
        methods: {

            changeStep(step) {

                this.$store.commit({
                    type: 'changeActiveConfigurationStep',
                    step: step
                })

            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                };

                this.$store.commit(arg);

                return arg.out;

            },

            selectElement(id, name, imgSrc, multiple_fans) {

                this.$store.commit({
                    type: 'selectSecondStepElement',
                    id: id,
                    name: name,
                    imgSrc: imgSrc,
                    multiple_fans: multiple_fans,
                });

                this.changeStep(3);
            },

        },
    }
</script>